import { FETCH_DEALER_SUCCESS, SELECT_DEALER, UPDATE_DEALER_REQUEST } from 'constants/ActionTypes';
import * as types from 'modules/dealerConfiguration/administration/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {'FAILED' | 'SUCCESS' | null} IntegrationStatus */
/** @type {IntegrationStatus} */
export const initialState = null;

const reset = () => initialState;

const success = () => 'SUCCESS';

const failed = () => 'FAILED';

const subscriptionStatusReducer = source =>
  createReducer(
    initialState,
    {
      [SELECT_DEALER]: reset,
      [LOCATION_CHANGE]: reset,
      [FETCH_DEALER_SUCCESS]: reset,
      [UPDATE_DEALER_REQUEST]: reset,
    },
    [
      {
        matcher: ({ type, meta }) => type === types.SUBSCRIBE_INTEGRATION_FAILURE && meta.source === source,
        reducer: failed,
      },
      {
        matcher: ({ type, meta }) => type === types.SUBSCRIBE_INTEGRATION_SUCCESS && meta.source === source,
        reducer: success,
      },
    ]
  );

export default subscriptionStatusReducer;
